<template>
    <p class="has-text-right">
        <a :href="link" class="button is-medium is-light is-outlined" :class="classBtn">
            {{ text }}
        </a>
    </p>
</template>

<script>
export default {
    name:'app-centered-button',
    props: ['link','text', 'classBtn']
};
</script>



// WEBPACK FOOTER //
// src/components/layout/MoreButton.vue